// Carga en el NAVEGADOR de las fuentes de @logiacare/hce-pdf (Vite resuelve
// `?url` al asset con hash). Desde el 2026-09-12 los documentos firmados los
// arma el servidor; esto solo lo usa la copia de historia clínica
// (paciente/pdfCopiaHistoria.ts), que no se firma. Se cachea la promesa.
import type { FuentesPdf } from '@logiacare/hce-pdf';
import newsreaderSemiBoldUrl from '@logiacare/hce-pdf/fonts/Newsreader-SemiBold.ttf?url';
import ibmPlexSansRegularUrl from '@logiacare/hce-pdf/fonts/IBMPlexSans-Regular.ttf?url';
import ibmPlexSansMediumUrl from '@logiacare/hce-pdf/fonts/IBMPlexSans-Medium.ttf?url';
import ibmPlexSansSemiBoldUrl from '@logiacare/hce-pdf/fonts/IBMPlexSans-SemiBold.ttf?url';

let cache: Promise<FuentesPdf> | null = null;

export function cargarFuentesPdfNavegador(): Promise<FuentesPdf> {
  cache ??= Promise.all([newsreaderSemiBoldUrl, ibmPlexSansRegularUrl, ibmPlexSansMediumUrl, ibmPlexSansSemiBoldUrl].map((url) => fetch(url).then((r) => r.arrayBuffer()))).then(
    ([serifSemiBold, sansRegular, sansMedium, sansSemiBold]) => ({
      serifSemiBold: serifSemiBold!,
      sansRegular: sansRegular!,
      sansMedium: sansMedium!,
      sansSemiBold: sansSemiBold!,
    }),
  );
  return cache;
}
